// utils
import { ApiParameters, WrapperService } from './wrapper';
// utils

import { apiConfig } from 'config';
import { ILoginForm } from 'utils/login';
import { IUserListParams } from '../@types/user';

// ----------------------------------------------------------------------

export class UserService {
  public apiService: WrapperService = new WrapperService();

  private userMgtPrefix = 'user';

  getUserDetails(email?: string) {
    const url = `/${this.userMgtPrefix}/details${email ? `/${encodeURIComponent(email)}` : ``}`;
    const apiParam: ApiParameters = {
      baseURL: apiConfig.user_mgt,
      method: 'GET',
      url: url
    };
    return this.apiService.httpCall(apiParam);
  }

  public submitUser(method: string | undefined, body: any, url: string | undefined) {
    const apiParam = {
      baseURL: apiConfig.user_mgt,
      method: method,
      url: url,
      body: body
    };
    return this.apiService.httpCall(apiParam);
  }

  getUsers({
    page = 0,
    size = 10,
    orderBy,
    order,
    ownerId,
    boostGroupId,
    subBoostGroupId,
    roleCode,
    fuzzySearchInput
  }: IUserListParams) {
    const sort = `${orderBy},${order}`;
    const apiParam = {
      baseURL: apiConfig.user_mgt,
      method: 'GET',
      url: `/${this.userMgtPrefix}/search`,
      params: {
        page,
        size,
        sort,
        ...(ownerId && { ownerId }),
        ...(boostGroupId && { boostGroupId }),
        ...(subBoostGroupId && { subBoostGroupId }),
        ...(roleCode && { roleCode }),
        ...(fuzzySearchInput && { fuzzySearchInput })
      }
    };
    return this.apiService.httpCall(apiParam);
  }

  getSitesByUser(userId: number, currentRows = 0, records = 20) {
    const apiParam = {
      method: 'GET',
      baseURL: apiConfig.site_energy,
      headers: {
        'Content-Type': 'application/json'
      },
      url: `/sites/user/${userId}?currentRow=${currentRows}&limit=${records}`,
      responseType: 'json'
    };
    return this.apiService.httpCall(apiParam);
  }

  getRoles() {
    const apiParam = {
      baseURL: apiConfig.user_mgt,
      method: 'GET',
      url: `/role/all`
    };
    return this.apiService.httpCall(apiParam);
  }

  setPasswordFirstTime(formData: ILoginForm) {
    const apiParam = {
      baseURL: apiConfig.user_mgt,
      method: 'POST',
      body: formData,
      url: `/${this.userMgtPrefix}/invite/activation`
    };
    return this.apiService.httpCall(apiParam);
  }

  updatePassword(formData: ILoginForm) {
    const apiParam = {
      baseURL: apiConfig.user_mgt,
      method: 'POST',
      body: formData,
      url: `/${this.userMgtPrefix}/updatePassword`
    };
    return this.apiService.httpCall(apiParam);
  }

  resetPassword(formData: ILoginForm) {
    const apiParam = {
      baseURL: apiConfig.user_mgt,
      method: 'PUT',
      body: formData,
      url: `/${this.userMgtPrefix}/resetPassword`
    };
    return this.apiService.httpCall(apiParam);
  }

  forgotPassword(formData: ILoginForm) {
    const apiParam = {
      baseURL: apiConfig.user_mgt,
      method: 'PUT',
      body: formData,
      url: `/${this.userMgtPrefix}/forgotPassword`
    };
    return this.apiService.httpCall(apiParam);
  }
}
